const FEATURE_FLAGS = {
  generalStatistics: "fe_md_general_statistics",
  seatingChart: "seating_chart",
  featureFlagTest: "feature_flag_test",
  classification: "fe_md_session_classification",
  app_config: "fe_md_app_config",
  capacityManagement: "cross_session_capacity_management",
  sessionsAnalytics: "fe_md_session_analytics",
  in_app_guidance: "fe_md_in_app_guidance",
  hidden_badges: "cross_shop_hidden_badges",
  callOutBranch: "fe_md_call_out_brand",
  hasBadgeFlow: "cross_has_badge_flow",
  exportSessions: "fe_md_export_sessions",
  exportUsersCustomFields: "fe_md_export_all_custom_fields",
  blinkTable: "cross_blink_table",
  blinkTableFilter: "fe_md_blink_table_filter",
  blinkTableRecordControl: "fe_md_blink_table_record_control",
  blinkTableMultipleViews: "fe_md_blink_table_multiple_views",
  beeFreeTemplateBuilder: "fe_md_bee_free_template_builder",
  extractFlightAI: "fe_md_ai_extract_flight",
  aiChatbot: "fe_md_ai_chatbot",
  beeFreePageBuilder: "fe_md_bee_free_page_builder",
  linkedBadges: "cross_linked_badges",
  multipleAssignedPasses: "cross_multiple_badge_assignment",
  formBuilder: "fe_md_foundation_form_builder",
  bulkTransfer: "cross_bulk_transfer",
  crossMigrationFormFieldsToCustomFields:
    "cross_migration_form_fields_to_custom_fields",
  bulkOrderCreation: "fe_md_bulk_order_creation",
  cancelEvent: "cross_cancel_event",
  deleteEvent: "cross_delete_event",
  leadCapture: "cross_lead_capture",
  crossDynamicAssignForm: "cross_dynamic_assgin_form",
  rsvp: "cross_badge_access_rsvp",
  eventTheming: "cross_event_theming_enabled",
  bulkAssignBadges: "fe_md_bulk_assign_badges",
  metricsSessionDemandCount: "fe_md_metrics_session_demand_count",
  metricsSessionScansPerHour: "fe_md_metrics_session_scans_per_hour",
  metricsVenueScansPerHour: "fe_md_metrics_venue_scans_per_hour",
  metricsBadgePrintingPerHour: "fe_md_metrics_badge_printing_per_hour",
  metricsSalesPerBadgeType: "fe_md_metrics_sales_per_badge_type",
  metricsSalesPerDay: "fe_md_metrics_sales_per_day",
  metricsSalesPerCountry: "fe_md_metrics_sales_per_country",
  metricsDailyStatisticsPage: "fe_md_metrics_daily_statistics_page",
  metricsExportDailyStatistics: "fe_metrics_export_daily_metrics",
  DynamicFieldsUseInFiltration: "cross_use_in_filtration_feature",
};

export default FEATURE_FLAGS;
